import React from 'react';

const Contact: React.FC = () => {
  return (
    <section className="content-section">
      <div className="container">
        <h1 className="section-title">Contact Us</h1>
        <p style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)', fontSize: '1.2rem' }}>
          Ready to book a show? Have questions about our music? Get in touch!
        </p>
        
        
        <div style={{ textAlign: 'center', marginTop: 'var(--spacing-xl)' }}>
          <h3>Direct Contact</h3>
          <p><strong>Email:</strong> <a href="mailto:lostsignalmn@gmail.com">lostsignalmn@gmail.com</a></p>
          <p><strong>Facebook:</strong> <a href="https://m.me/lostsignalmn" target="_blank" rel="noopener noreferrer">Message us on Facebook</a></p>
        </div>
        
        <div style={{ marginBottom: 'var(--spacing-xl)', borderRadius: '8px', overflow: 'hidden' }}>
          <iframe 
            src="https://careful-snipe-878.notion.site/ebd/29f3e699237d80c78c34e6a6d3f5abbb" 
            width="100%" 
            height="1200" 
            frameBorder="0" 
            allowFullScreen 
            title="Contact Form"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
